module.exports = [{"type":"title","text":"2024-07-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"USDT-M Perp Futures: The ClientOrderId field in the request will be automatically converted to lowercase by the system."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-07-22.json
// module id = OOYK
// module chunks = 3